<template>
  <GravManagerWrapper :id="id" :componentName="componentName" :properties="props">
    <component :is="WidgetCard" v-bind="{ style: $attrs.style, ...changableProps }">
      <template v-for="slotName in Object.keys($slots)" #[slotName]="slotProps">
        <slot :name="slotName" v-bind="slotProps" />
      </template>
    </component>
  </GravManagerWrapper>
</template>

<script setup lang="ts">
import { useChangableProps } from '@/composables/useChangableProps';
import GravManagerWrapper from './GravManagerWrapper.vue';
import { WidgetCardProps } from './WidgetCard.ts';
import WidgetCard from './WidgetCard.vue';

const componentName = 'ui-widget-card';
const $slots = defineSlots<Record<string, unknown>>();

const props = defineProps<WidgetCardProps>();
const changableProps = useChangableProps(componentName, props);

</script>
